module.exports = __webpack_public_path__ + "0dbcd0ad9e2331de3f94eab99e960078.png";